import { render, staticRenderFns } from "./MetricasCocina.vue?vue&type=template&id=14e29a86&scoped=true"
import script from "./MetricasCocina.vue?vue&type=script&lang=js"
export * from "./MetricasCocina.vue?vue&type=script&lang=js"
import style0 from "./MetricasCocina.vue?vue&type=style&index=0&id=14e29a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e29a86",
  null
  
)

export default component.exports